import { render } from "./EditDistributorView.vue?vue&type=template&id=3fcc80a3"
import script from "./EditDistributorView.vue?vue&type=script&lang=js"
export * from "./EditDistributorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__